(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["reveal-on-scroll"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('reveal-on-scroll')) {
    class RevealOnScroll extends HTMLElement {
      connectedCallback() {
        const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

        if (prefersReducedMotion) {
          this.classList.add('is-visible');
          return;
        }

        this.safetyTimeout = window.setTimeout(() => {
          this.classList.add('is-visible');
        }, 2000);

        this.intersectionObserver = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              if (!entry.isIntersecting) return;
              entry.target.classList.add('is-visible');
              this.intersectionObserver.unobserve(entry.target);
              window.clearTimeout(this.safetyTimeout);
            });
          },
          { threshold: 0.15, rootMargin: '0px 0px -10% 0px' }
        );

        this.intersectionObserver.observe(this);
      }

      disconnectedCallback() {
        if (this.intersectionObserver) {
          this.intersectionObserver.disconnect();
        }
        if (this.safetyTimeout) {
          window.clearTimeout(this.safetyTimeout);
        }
      }
    }

    customElements.define('reveal-on-scroll', RevealOnScroll);
  }
  } catch(e) { console.error(e); }
})();

})();
